(() => {
  'use strict';
  let inflight = null;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[c]));
  function complete(db, invitationId, email) {
    if (inflight) return inflight;
    inflight = new Promise(resolve => {
      const layer = document.createElement('div');
      layer.className = 'aa-invite-setup';
      layer.setAttribute('role','dialog');
      layer.setAttribute('aria-modal','true');
      layer.setAttribute('aria-label','Complete your Artisan’s Avenue account');
      layer.innerHTML =
        '<div class="aa-invite-setup__card">' +
        '<p class="aa-invite-setup__brand">Artisan’s Avenue</p>' +
        '<h1>Set up your Workspace login</h1>' +
        '<p>You have been invited to your store’s Workspace. Create a password to finish activating your access.</p>' +
        '<p class="aa-invite-setup__email">'+esc(email)+'</p>' +
        '<form data-aa-invite-setup-form>' +
        '<label>New password<input name="password" type="password" autocomplete="new-password" required minlength="12"></label>' +
        '<label>Confirm password<input name="confirm" type="password" autocomplete="new-password" required minlength="12"></label>' +
        '<p>Use at least 12 characters, including uppercase, lowercase, a number and a symbol.</p>' +
        '<p data-aa-invite-setup-error role="alert"></p>' +
        '<button type="submit">Activate My Workspace</button>' +
        '</form>' +
        '<p class="aa-invite-setup__help">Need assistance? Contact Artisan’s Avenue.</p>' +
        '</div>';
      document.body.appendChild(layer);
      const form = layer.querySelector('form');
      const msg = layer.querySelector('[data-aa-invite-setup-error]');
      form.querySelector('input').focus();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button');
        const password = form.elements.password.value;
        const confirmation = form.elements.confirm.value;
        if (password !== confirmation) {msg.textContent='The passwords do not match.';return;}
        if (password.length < 12) {msg.textContent='Use a password at least 12 characters long.';return;}
        button.disabled=true;
        button.textContent='Securing your account...';
        msg.textContent='';
        try {
          const { error: passwordError } = await db.auth.updateUser({ password });
          if (passwordError) throw Error(passwordError.message || 'Password could not be saved.');
          button.textContent='Activating your Workspace...';
          const { data, error } = await db.functions.invoke('aa-client-team-service', {
            body: {action:'accept-invitation',requestId:invitationId}
          });
          if (error || !data?.success) throw Error(data?.error || 'Your access could not be activated. Please contact Artisan’s Avenue.');
          const url = new URL(window.location.href);
          url.searchParams.delete('aa_accept_invite');
          window.history.replaceState(window.history.state,'',url.pathname+url.search+url.hash);
          layer.remove();
          resolve(true);
        } catch (error) {
          msg.textContent = error?.message || 'Unable to activate Workspace.';
          button.textContent='Try Again';
          button.disabled=false;
          // Never activate a membership when confirmation or password creation failed.
        }
      });
    }).finally(() => {inflight=null;});
    return inflight;
  }
  window.AAClientInvitationSetup={ complete };
})();
